import { memo, useCallback, useState } from 'react';
import { Rating, Picture, Uploader, Modal } from '@ui';
import { star, star_noactive } from '@images';
import LeaveFeedBackFormConsAndPros from '../LeaveFeedbackModal/LeaveFeedbackContent/components/LeaveFeedbackUserForm/components/LeaveFeedBackFormConsAndPros';
import useWindowSize from '@customHooks/useWindowSize';
import { getRatingText } from '@utils/ratingText';
import API from '@api';
import './index.scss';

const EditReviewModal = props => (
  <Modal
    framed
    size='fromMd:w-[550px] fromMd:max-w-[550px] sm:w-full sm:min-h-[356px]'
    className='flex flex-col items-center justify-center'
    placementMobile='fullscreen'
    onClose={props.onCloseModal}
  >
    <EditReviewModalComp {...props} />
  </Modal>
);

// reviewType = 'shop' || 'product'
const EditReviewModalComp = ({
  id,
  onCloseModal,
  onSuccessFulSubmit,
  rating,
  text = '',
  tags,
  attachedFiles = []
}) => {
  const { isMobile } = useWindowSize();
  const [formData, setFormData] = useState({
    comment: { value: text, error: false },
    rating: { value: rating, error: false },
    uploadedPhotos: {
      value: attachedFiles?.map(item => ({
        id: item.id,
        fileUrl: item.big,
        isVideo: item.isVideo
      })),
      error: false
    },
    prosAndCons: { value: tags || [] }
  });
  const onChangeFormData = useCallback(
    ({ field, value }) =>
      setFormData(prev => ({
        ...prev,
        [field]: { ...prev[field], value }
      })),
    []
  );

  const getDataFromForm = ({ field, value }) => {
    let newState = { ...formData };
    if (
      newState.comment.error &&
      field === 'prosAndCons' &&
      value.length !== 0
    ) {
      newState = {
        ...newState,
        comment: { ...newState.comment, error: '' }
      };
    }
    newState = { ...newState, [field]: { ...newState[field], value } };
    setFormData(newState);
  };

  const onSubmit = e => {
    e.preventDefault();
    const data = {
      objectId: +id,
      instance: 'Reviews',
      commentType: 'Review',
      rating: formData.rating.value,
      commentText: formData.comment.value,
      filesIds: formData.uploadedPhotos.value?.map(item => +item.id),
      tags: formData.prosAndCons.value
    };
    API.editPeopleReviewById({ data })
      .then(res => onSuccessFulSubmit())
      .catch(error => console.log('error:', error));
  };
  return (
    <form onSubmit={onSubmit} className='EditReviewModal'>
      <div className='EditReviewModal__heading'>Редактировать отзыв</div>
      <div className='EditReviewModal__rating-wrapper'>
        <Rating
          className='EditReviewModal__rating'
          onChange={stars => getDataFromForm({ field: 'rating', value: stars })}
          initialRating={formData.rating.value}
          fullSymbol={<Picture icon={star} height='20' />}
          emptySymbol={<Picture icon={star_noactive} height='20' />}
        />
        <div className='EditReviewModal__rating-text'>
          {getRatingText(formData.rating.value)}
        </div>
      </div>
      <LeaveFeedBackFormConsAndPros
        tags={formData.prosAndCons.value}
        activeTab='review-shop'
        isRatingGood={formData.rating.value > 3}
        isMobile={isMobile}
        getDataFromForm={getDataFromForm}
      />
      <textarea
        className='EditReviewModal__text-area'
        value={formData.comment.value}
        onChange={e =>
          onChangeFormData({ field: 'comment', value: e.target.value })
        }
      />
      <Uploader
        className='EditReviewModal__uploader'
        uniqueId={id}
        maximumFilesQuantity='5'
        getPhotos={onChangeFormData}
        uploadedPhotos={formData.uploadedPhotos.value}
      />
      <div className='EditReviewModal__btns'>
        <button
          type='button'
          className='EditReviewModal__btn'
          onClick={onCloseModal}
        >
          Отменить
        </button>
        <button
          type='submit'
          className='EditReviewModal__btn EditReviewModal__btn--submit-btn'
        >
          Сохранить{!isMobile ? ' изменения' : ''}
        </button>
      </div>
    </form>
  );
};

export default memo(EditReviewModal);
